import Muted from '@/SVG/Muted'
import Unmuted from '@/SVG/Unmuted'
import { useAudio } from '@/context/AudioContext'

export default function MuteButton() {
  const { setMuted, isMuted } = useAudio()
  const handleClick = () => {
    console.debug(
      `MuteButton clicked, toggling mute state ${isMuted ? 'off' : 'on'} => ${!isMuted ? 'off' : 'on'}`,
      'audio'
    )
    setMuted(!isMuted)
  }
  return (
    <button type={'button'} onClick={handleClick}>
      {isMuted ? <Muted /> : <Unmuted />}
    </button>
  )
}

export { MuteButton }
